import { useCallback, useEffect, useState } from 'react'

export default function useLocalStorage(key, defaultState) {
  const [value, setValue] = useState(
    JSON.parse(localStorage.getItem(key)) ?? defaultState,
  )

  useEffect(() => {
    function handleStorageChange({ detail }) {
      if (detail.key === key) {
        setValue(detail.value)
      }
    }

    globalThis.addEventListener(`${key}_updated`, handleStorageChange)
    return () => {
      globalThis.removeEventListener(`${key}_updated`, handleStorageChange)
    }
  }, [key])

  const setValueFn = useCallback(
    (v) => {
      setValue((prev) => {
        const newValue = typeof v === 'function' ? v(prev) : v
        localStorage.setItem(key, JSON.stringify(newValue))
        globalThis.dispatchEvent(
          new CustomEvent(`${key}_updated`, { detail: { key, value: newValue } }),
        )
        return newValue
      })
    },
    [key],
  )
  return [value, setValueFn]
}
